<template>
  <h2 v-translate="{name: name}"
      :class="{'heading-3': $mq.desktop, 'heading-4': !$mq.desktop}"
      class="welcome-heading has-text-centered-mobile">
    Welcome, %{ name }.
  </h2>
</template>

<script>
export default {
  props: {
    name: {type: String}
  }
};
</script>
